import { StoreIdentifierName } from 'types';
import {
  getFeatureFlagByNameSelector,
  headerCTATaxoSelector,
  headerNavItemsSelector,
  progressiveHeaderCTATaxoSelector,
  progressiveHeaderNavItemsSelector,
  storeIdentifierNameSelector,
  headerClientLoadingSelector,
  progressiveHeaderClientLoadingSelector,
} from 'store/selectors';
import { useAppSelector } from 'store/store';
import usePARTY from 'hooks/usePARTY';
import ErrorBoundaryWithLogger from 'components/common/ErrorBoundary/ErrorBoundary';

import TopNavBar from './TopNavBar';
import TopNavBarNoContent from './TopNavBarNoContent';
import TopNavPending from './TopNavBarPending';

const TopNavBarContainer = () => {
  const progressiveHeaderDesktopEnabled = useAppSelector(
    getFeatureFlagByNameSelector('progressiveTaxoDesktop'),
  );
  const headerTopMessageData = useAppSelector(headerCTATaxoSelector);
  const headerNavBarCtas = useAppSelector(headerNavItemsSelector);

  const progressiveHeaderTopMessageData = useAppSelector(progressiveHeaderCTATaxoSelector);
  const progressiveNavBarCtas = useAppSelector(progressiveHeaderNavItemsSelector);

  const topMessageData = progressiveHeaderDesktopEnabled
    ? progressiveHeaderTopMessageData
    : headerTopMessageData;
  const navBarCtas = progressiveHeaderDesktopEnabled ? progressiveNavBarCtas : headerNavBarCtas;

  const headerIsLoading = useAppSelector(headerClientLoadingSelector);
  const progressiveIsLoading = useAppSelector(progressiveHeaderClientLoadingSelector);

  const isLoading = progressiveHeaderDesktopEnabled ? progressiveIsLoading : headerIsLoading;

  const storeIdentifierName = useAppSelector(storeIdentifierNameSelector);
  const redirectToOtherVerticalsEnabled = useAppSelector(
    getFeatureFlagByNameSelector('redirectToOtherVerticals'),
  );
  const favoritesIconEnabled = useAppSelector(getFeatureFlagByNameSelector('addFavoritesEnabled'));
  const nikeConnectedEnabled = useAppSelector(getFeatureFlagByNameSelector('nikeConnectedEnabled'));
  const [nikeConnected] = usePARTY();

  if (!navBarCtas && isLoading) {
    return <TopNavPending />;
  }

  if (!navBarCtas) {
    throw new Error(
      'Homr did not return any headerNavBar content. Make sure the correct data is being returned! ',
    );
  }

  return (
    <ErrorBoundaryWithLogger componentId="Header-TopNavBar" fallback={<TopNavBarNoContent />}>
      <TopNavBar
        navBarCtas={navBarCtas}
        topMessageData={topMessageData}
        storeIdentifierName={storeIdentifierName as StoreIdentifierName}
        nikeConnected={nikeConnectedEnabled ? nikeConnected : null}
        redirectToOtherVerticalsEnabled={redirectToOtherVerticalsEnabled}
        favoritesIconEnabled={favoritesIconEnabled}
      />
    </ErrorBoundaryWithLogger>
  );
};

export default TopNavBarContainer;
